import { Component, OnInit } from '@angular/core';
import { HttpModule } from '@angular/http';
import { Router } from '@angular/router';

import * as _ from 'underscore';

// Service
import { AccountClientLogService } from '../../service/account-client-log/account-client-log.service';

@Component({
	selector: 'app-account-client-log',
	templateUrl: './account-client-log.component.html',
	providers: [
		AccountClientLogService,
		HttpModule
	]
})
export class AccountClientLogComponent implements OnInit {
	private token;
	private allItems: any[];
	public logs: any[];
	public permissoes: any[] = [];
	LogDataInicio: any = "";
	LogDataFim: any = "";
	LogUsuario: string = "";

	private dateTest: Date;

	constructor(private accountclientLogService: AccountClientLogService, private router: Router) {
		this.token = localStorage.getItem('yara.token');
	}

	searchLog(begindate, enddate, user) {
		this.accountclientLogService.searchLog(this.token, this.LogDataInicio, this.LogDataFim, this.LogUsuario).subscribe(result => {
			this.logs = result.Result;
		}, error => {
			console.log(error);
			
		})
	}

	ngOnInit() {
		this.permissoes = localStorage.getItem('yara.permissions') ? JSON.parse(localStorage.getItem('yara.permissions')) : [];
	}

}



// WEBPACK FOOTER //
// ./src/app/account-client/component/account-client-log/account-client-log.component.ts